export interface SelectOption {
  label: string;
  value: string | number;
  className?: string;
}
interface SelectProps extends React.HTMLAttributes<HTMLSelectElement> {
  displayLabel: string;
  onChange: (arg: React.ChangeEvent<HTMLSelectElement>) => void;
  options: SelectOption[];
  defaultValue?: string;
  icon?: JSX.Element;
}

const Select = ({
  options,
  displayLabel,
  className,
  onChange,
  icon,
  defaultValue,
  ...props
}: SelectProps) => (
  <div className="relative right-5 flex items-center">
    {icon && <span className="relative left-8">{icon}</span>}
    <select
      {...props}
      onChange={onChange}
      className={`select focus:outline-offset-0 bg-gray-100 text-2xs text-gray-600 font-light ${className}`}
      defaultValue={defaultValue || 'default'}
    >
      {defaultValue === undefined && (
        <option value="default">{displayLabel}</option>
      )}

      {options?.map((opt) => (
        <option value={opt.value} key={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
